import { humanDate } from "./humanDate";

export const adminPanel = release => {
	let now = new Date().getTime();
	let releaseInfo = "";
	if (release.langs) {
		releaseInfo = {
			langs: "",
			releaseTags: "",
			pubbed: "",
			status: "",
			feed: "",
			"sust-feed": "",
			featured: "",
			darkpage: "",
			editors: ""
		};
		let langKeys = Object.keys(release.langs);
		if (release.langs.en) {
			langKeys = langKeys.filter(lang => lang != "en").sort();
			langKeys.unshift("en");
		}
		// remove 'en' from keys, sort remainder;
		// if "en" then place 'en' at front,
		// to prefer "en" version for admins

		langKeys.forEach(lang => {
			releaseInfo.langs = `${releaseInfo.langs}<span data-lang="${lang}" class="lang-dot">${lang}</span>`;

			releaseInfo.releaseTags = `${releaseInfo.releaseTags}<span data-lang="${lang}" data-type="tags" data-more="${release.langs[lang].tags.join(", ")}"><span uk-icon="icon: info; ratio: 1.2"></span></span>`;

			releaseInfo.editors = `${releaseInfo.editors}<span data-lang="${lang}" data-type="editors" data-more="${release.langs[lang].createdBy},${release.langs[lang].created},${release.langs[lang].updatedBy ? release.langs[lang].updatedBy : "N/A"},${release.langs[lang].updated ? release.langs[lang].updated : "N/A"}"><span uk-icon="icon: info; ratio: 1.2"></span></span>`;

			releaseInfo.pubbed = `${releaseInfo.pubbed}<span data-lang="${lang}" data-type="pubbed" data-more="${humanDate(release.langs[lang].pubTime, true, ", ")}" data-state="${release.langs[lang].pubTime <= now ? "true" : "false"}"><span uk-icon="icon: info; ratio: 1.2"></span></span>`;

			releaseInfo.status = `${releaseInfo.status}<span data-lang="${lang}" data-toggle="status" data-state="${release.langs[lang].status}"><span class="toggle-icon" uk-icon="icon: ${release.langs[lang].status ? "check" : "close"}; ratio: 1.2"></span></span>`;

			releaseInfo.feed = `${releaseInfo.feed}<span data-lang="${lang}" data-toggle="dotcom" class="status-dot" data-state="${release.langs[lang].dotcom}"><span class="toggle-icon" uk-icon="icon: ${release.langs[lang].dotcom ? "check" : "close"}; ratio: 1.2"></span></span>`;

			releaseInfo["sust-feed"] = `${releaseInfo["sust-feed"]}<span data-lang="${lang}" data-toggle="dotcom-sust" class="status-dot" data-state="${release.langs[lang]["dotcom-sust"] ? release.langs[lang]["dotcom-sust"] : "false"}"><span class="toggle-icon" uk-icon="icon: ${release.langs[lang]["dotcom-sust"] ? "check" : "close"}; ratio: 1.2"></span></span>`;

			releaseInfo.featured = `${releaseInfo.featured}<span data-lang="${lang}" data-toggle="featured" class="status-dot" data-state="${release.langs[lang].featured}"><span class="toggle-icon" uk-icon="icon: ${release.langs[lang].featured ? "check" : "close"}; ratio: 1.2"></span></span>`;

			releaseInfo.darkpage = `${releaseInfo.darkpage}<span data-lang="${lang}" data-toggle="darkpage" class="status-dot" data-state="${release.langs[lang].darkpage}"><span class="toggle-icon" uk-icon="icon: ${release.langs[lang].darkpage ? "check" : "close"}; ratio: 1.2"></span></span>`;
		});
	}
	return releaseInfo;
};
